/// <reference path="../../Common/Helpers/GridEditorBase.ts" />
namespace GeniuzPOS.Product {

    @Serenity.Decorators.registerClass()
    export class PluDtEditor extends Serenity.Extensions.GridEditorBase<PluDtRow> {
        protected getColumnsKey() { return "Product.PluDt"; }
        protected getDialogType() { return PluDtDialog; }
        protected getLocalTextPrefix() { return PluDtRow.localTextPrefix; }

        public qnNo: number;

        public myPassValue: string;
        public myPassValue1: string;
        public myPassValue2: string;
        public myPassValue3: string;
        public myPassValue4: string;
        public myPassValue5: string;
        public myPassValue6: string;
        public myPassValue7: string;
        public myPassValue8: string;
        

        constructor(container: JQuery) {
            super(container);
        
        }      

        protected getButtons(): Serenity.ToolButton[] {
            var buttons = super.getButtons();
            //let self = this;
            //self.toolbar.findButton('add-button').text('สร้างรายการ');
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);
            buttons.push(
                {
                    title: Q.text("สร้าง บาร์โค๊ด"),	// *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-add',
                    onClick: () => {
                        this.createEntityDialog(this.getItemType(), dlg => {


                            var dialog = dlg as PluDtDialog;
                            dialog.onSave = (opt, callback) => this.save(opt, callback);
                            var entity = this.getNewEntity() as PluDtRow;

                            entity.SkuCode = this.myPassValue;
                            //entity.PluCode = this.myPassValue;
                            entity.PluDesc = this.myPassValue1;
                            entity.PluShortDesc = this.myPassValue1.length > 30 ? this.myPassValue1.substring(0, 30) : this.myPassValue1;
                            entity.StyleId = this.myPassValue2;
                            entity.ColorId = this.myPassValue3;
                            entity.MatTypeId = this.myPassValue4;
                            entity.SizeId = this.myPassValue5;
                            entity.TasteId = this.myPassValue6;
                            entity.ConceptCode = this.myPassValue8;
                            entity.SellUnit = this.myPassValue7;  

                            dialog.loadEntityAndOpenDialog(entity, false);
                           
                        });
                    },
                }
            );
            
            return buttons;
        }
    
        protected getSlickOptions() {
            var opt = super.getSlickOptions();
            opt.showFooterRow = true;
            return opt;
        }

       

        protected getViewOptions() {
            var opt = super.getViewOptions();
            opt.localSort = true;
            return opt;
        }

        protected usePager() {
            return false;
        }

    }
}

